import { render, staticRenderFns } from "./benefits.vue?vue&type=template&id=4d25ea02&scoped=true"
import script from "./benefits.vue?vue&type=script&lang=js"
export * from "./benefits.vue?vue&type=script&lang=js"
import style0 from "./benefits.vue?vue&type=style&index=0&id=4d25ea02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d25ea02",
  null
  
)

export default component.exports